/**
 * @generated SignedSource<<1e4603aae3bf482dc60e5d19ffb816ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupReportOrderValue = "DATE" | "POPUP" | "POPUP_GROUP" | "FUNNEL" | "PAGE" | "PAGE_VIEW_USER" | "READY_USER" | "CLOSE_CLICK" | "CLICK_USER" | "CONVERSION_USER" | "IMP_CONVERSION_USER" | "READY_CONVERSION_USER" | "DROP_USER" | "DROP_CONVERSION_USER" | "UNIQUE_USER" | "TOTAL_CONVERSION_USER" | "CLICK_USER_RATE" | "CONVERSION_CLICK_RATE" | "CONVERSION_IMP_RATE" | "TOTAL_CONVERSION_RATE" | "CONVERSION_DROP_RATE" | "MOBILE_RATE" | "TABLET_RATE" | "PC_RATE" | "%future added value";
export type AdminPopupReportFilterInput = {
  startDate: string;
  endDate: string;
  siteIds: ReadonlyArray<string>;
};
export type PopupReportOrderInput = {
  value: PopupReportOrderValue;
  isDesc?: boolean | null;
};
export type AdminReportResults_Query$variables = {
  filter: AdminPopupReportFilterInput;
  order?: PopupReportOrderInput | null;
};
export type AdminReportResults_QueryVariables = AdminReportResults_Query$variables;
export type AdminReportResults_Query$data = {
  readonly adminSitePopupReport: {
    readonly rows: ReadonlyArray<{
      readonly siteId: number | null;
      readonly siteName: string | null;
      readonly uniqueUser: number;
      readonly readyUser: number;
      readonly pageViewUser: number;
      readonly closeClick: number;
      readonly clickUser: number;
      readonly clickUserRate: number;
      readonly totalConversionUser: number;
      readonly totalConversionRate: number;
    }>;
  };
};
export type AdminReportResults_QueryResponse = AdminReportResults_Query$data;
export type AdminReportResults_Query = {
  variables: AdminReportResults_QueryVariables;
  response: AdminReportResults_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "order",
        "variableName": "order"
      }
    ],
    "concreteType": "AdminSitePopupReport",
    "kind": "LinkedField",
    "name": "adminSitePopupReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminSitePopupReportRow",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "siteId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "siteName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uniqueUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readyUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageViewUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closeClick",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clickUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clickUserRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalConversionUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalConversionRate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminReportResults_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminReportResults_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d805045086d69d4faa0e3669b777d07b",
    "id": null,
    "metadata": {},
    "name": "AdminReportResults_Query",
    "operationKind": "query",
    "text": "query AdminReportResults_Query(\n  $filter: AdminPopupReportFilterInput!\n  $order: PopupReportOrderInput\n) {\n  adminSitePopupReport(filter: $filter, order: $order) {\n    rows {\n      siteId\n      siteName\n      uniqueUser\n      readyUser\n      pageViewUser\n      closeClick\n      clickUser\n      clickUserRate\n      totalConversionUser\n      totalConversionRate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "650d53a114e870794fd760c246ca2533";

export default node;
